import { JournalEntryEntity } from "api/src/journal/entities/journal-entry.entity";
import { useQuery } from "react-query";

import { api } from "../util/api";

export function useJournalEntries() {
  return useQuery<JournalEntryEntity[]>(
    ["journal-list"],
    async () => {
      const response = await api.get<JournalEntryEntity[]>("journal", {});

      if (response.status === 200) {
        return response.data;
      }

      throw Promise.reject("Couldn't fetch journal entries");
    },
    {
      keepPreviousData: true,
    }
  );
}
